import { EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { clients } from '../../process-runner-select/shared/process-run.service';
import { UIService } from '../../shared/ui.service';
import { FORDEARLERDATA, GETNEWVALUES, NOCLIENTSEED, RELOADNEWVALUES, SEED, SeedService, } from '../shared/seed.service';
import { ClientSeedPost, commonKeys, Iclientseed, IclientseedDev, IdealerseedDev, IpostDealer } from '../shared/seedinterfaces';

@Component({
  selector: 'app-seed-table',
  templateUrl: './seed-table.component.html',
  styleUrls: ['./seed-table.component.css']
})
export class SeedTableComponent implements OnInit {
  @Input() reason: string;
  @Input() title_page: string="";
  @Input() data: IclientseedDev[] | IdealerseedDev[];
  @Input() clients: clients[];
  @Input() clientsstore: clients[] = [];
  mainChecked: boolean = false;
  appHistory: string[] = ["ALL"];
  @Output() addRemvSelectRow = new EventEmitter<{ Toadd: boolean, id: number }>();
  @Output() addRemvSelectRowArr = new EventEmitter<any[]>();
  @Output() addSeed = new EventEmitter<{client:string}>();
  constructor(private seedser: SeedService, private uis: UIService) {
    this.refreshSubscriber$ = seedser.refresher;
    this.senderSubscriber$ = seedser.sender;
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngAfterViewInit() {
      this.dataSource.paginator = this.paginator;

  }

  addseed() {
    let cl = this.selectClient;
    if (this.selectClient == "" && this.reason == SEED) {
      cl = "0";
    }
    this.addSeed.emit({ client: cl });
  }

  ELEMENT_DATA: IclientseedDev[] | IdealerseedDev[] = []
  dataSource = new MatTableDataSource<IclientseedDev | IdealerseedDev>(this.ELEMENT_DATA);
  displayedColumns: string[] = ['chk', 'seedText', 'group_Id', 'clientId', 'isBroard', 'isPhrase', 'isExact', 'broad_cpc', 'phrase_CPc', 'exactCPC', 'save', 'del'];
  refreshSubscriber$: EventEmitter<string>;
  senderSubscriber$: EventEmitter<Boolean>;
  subscriptionRefrssh: Subscription;
  subscriptionsend: Subscription;
  subscriptionOpenAsker: Subscription;
  dataRefresher() {
    this.mainChecked = false;
    this.ELEMENT_DATA = this.data
    this.dataSource.data = this.ELEMENT_DATA
    this.dataSource.paginator = this.paginator;
  }

  appChange(e) {
    let app: string = e?.value.toUpperCase();
    this.appHistory.push(app);
    let lenght = this.appHistory.length;
    let currentAPp = this.appHistory[lenght - 1];
    //let prevprev = (lenght - 2)>=0?this.appHistory[lenght - 2]:null;
    //let prevTwo = (lenght - 3) >= 0 ? this.appHistory[lenght - 3] : null;
    console.log(this.appHistory)
    this.selectClient = "";
    if (this.instanceisIdealerArr(this.ELEMENT_DATA)) {
      if (currentAPp == "ALL") {
        this.clients = this.clientsstore;
        this.dataSource.data = this.ELEMENT_DATA;
        this.dataSource.filter = ''

      } else {
        this.clients = this.clientsstore.filter((e => e.productCode == app));
        this.dataSource.data = this.ELEMENT_DATA.filter(e => e.productCode == app);
        //if (currentAPp !== prevTwo) {
        this.dataSource.filter = ''
        //}
      }
    }
  }
  selectClient: string=""
  ngOnDestroy(): void {
    this.subscriptionsend.unsubscribe();
    this.subscriptionRefrssh.unsubscribe();
    if (this.subscriptionOpenAsker) {
    this.subscriptionOpenAsker.unsubscribe();
    }
  }
  applyFilter(event) {
      const filterValue: number = event?.value;
    if (filterValue == 0) {
      this.dataSource.filter = '';
    } else {
      this.dataSource.filter = filterValue.toString();
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }

  showMsg() {
    if (this.dataSource.data.filter((e) => e.selected).length == 0) {
      this.uis.openDialog({ head: "Warning", msg: "Sorry no keyword selected" });

    }

  }

  ngOnInit(): void {
    this.clientsstore = this.clients;
    this.dataSource.filterPredicate = (data: IclientseedDev | IdealerseedDev, filter: string) => !filter || data.clientID.toString() == filter;



    this.subscriptionsend = this.senderSubscriber$.subscribe((r) => {
      if (r == true && this.reason == NOCLIENTSEED) {
        let d: any[] = this.dataSource.data.filter((e) => e.selected) //IclientseedDev[] | IdealerseedDev[]
          this.seedser.reciever.emit(d);
      }
    })

    this.subscriptionRefrssh =   this.refreshSubscriber$.subscribe(
      (r) => {
        if (r == RELOADNEWVALUES) {
          setTimeout(() => { this.dataRefresher(); }, 1000)
        }
      }
    );
    //this.dataRefresher();
    if (this.reason == NOCLIENTSEED) {
      this.displayedColumns.splice(this.displayedColumns.indexOf('clientId'), 1)
    } else if (this.reason == SEED) {
      this.displayedColumns.splice(this.displayedColumns.indexOf('chk'), 1)

    }
    else if (this.reason == FORDEARLERDATA) {
      this.displayedColumns.splice(this.displayedColumns.indexOf('chk'), 1)
      this.displayedColumns.splice(this.displayedColumns.indexOf('del'), 1)
      this.displayedColumns.splice(this.displayedColumns.indexOf('seedText'), 1)
      this.displayedColumns.splice(this.displayedColumns.indexOf('group_Id'), 1)
      this.displayedColumns.unshift("dealers")
    } 
  }

  deleteSeedCOnf(id: number) {
    if (!id) {
      this.uis.openDialog({ head: "Oops", msg: "Seed config not found" })
      return;
    }
    this.subscriptionOpenAsker= this.uis.openAsker({ head: "Warning", ask: "Do you really want to delete seed config" }).afterClosed().subscribe((r) => {
      if (r) {
        this.seedser.deleteConfigAdSeeds(id).subscribe((r: Iclientseed) => {
          if (r) {
            this.uis.openDialog({ head: "Success", msg: "Seed config deleted" });
         
          } else {
            this.uis.openDialog({ head: "Oops", msg: "Seed config not found" });
          }
          this.seedser.refresher.emit(GETNEWVALUES);

        }, (e) => {
          this.uis.openDialog({ head: "Oops", msg: "Seed config not found" });
        }
          )
      }
    })
  }

  selectAll(ex) {


    const skip = this.paginator.pageSize * this.paginator.pageIndex;
    let data = this.dataSource.filteredData;
    if (data.length == 0) {
      data = this.dataSource.data;
    }
    const pagedData = data.filter((u, i) => i >= skip)
      .filter((u, i) => i < this.paginator.pageSize);
    let s = [];
    pagedData.forEach((e) => {
      if (e["configAdSeedID"]) {
        s.push(e["configAdSeedID"]);
      }
    })
    this.dataSource.data.map((e) => {
      if (s.includes(e["configAdSeedID"]?e["configAdSeedID"]:null)) {
        e.selected = ex.checked;
      }
    })
    this.addRemvSelectRowArr.emit(this.dataSource.data.filter(e => e.selected))
  }

  handlePage() {
    if (this.reason !== FORDEARLERDATA) {

    let allTrue = true;
    const skip = this.paginator.pageSize * this.paginator.pageIndex;
    let data = this.dataSource.filteredData;
    if (data.length == 0) {
      data = this.dataSource.data;
    }
    const pagedData = data.filter((u, i) => i >= skip)
      .filter((u, i) => i < this.paginator.pageSize);
    pagedData.forEach((e) => {
      if (e.selected == false) {
        allTrue = false;
      }
    })
    if (allTrue) {
      this.mainChecked = true;
    } else {
      this.mainChecked = false;
      }
    }
  }

  changeStatus(e, v) {
    this.addRemvSelectRow.emit({ Toadd: e?.checked, id:v})
  }

  instanceisIclient(object: any): object is IclientseedDev {
    return 'configAdSeedID' in object;
  }
  instanceisIdealer(object: any): object is IdealerseedDev {
    return 'dealerId' in object;
  }
  instanceisIdealerArr(object: any): object is IdealerseedDev[] {
    return 'dealerId' in object[0];
  }

  saveCaller(row) {
    if (this.reason == NOCLIENTSEED || this.reason == SEED) {
      this.save<IclientseedDev>(row);
    } else if (this.reason == FORDEARLERDATA) {
      this.save<IdealerseedDev>(row);
    } else {
      this.uis.openDialog({ head: "Oops", msg: "Something going wrong, Please contact admin" })
    }

   
  }

  save<A>(row: A) {
    if (this.instanceisIclient(row)) {
      let data: ClientSeedPost = {
        clientID: row.clientID,
        configAdGroupID: row.configAdGroupID,
        configAdSeedID: row.configAdSeedID,
        seedText: row.seedText,
        isBroad: row.isBroad,
        isPhrase: row.isPhrase,
        isExact: row.isExact,
        broadCpc: row.broadCpc,
        phraseCpc: row.phraseCpc,
        exactCpc: row.exactCpc
      }
      this.seedser.saveConfigAdseed(data).subscribe((r: { message: string, id: number }) => {
        this.uis.openDialog({ head: "Success", msg: r.message });
        this.seedser.refresher.emit(GETNEWVALUES);
      }, (er) => {

      })

    } else if (this.instanceisIdealer(row)) {
      let data: IpostDealer = {
        dealerId: row.dealerId,
        isBroad: row.isBroad,
        isPhrase: row.isPhrase,
        isExact: row.isExact,
        broadCpc: row.broadCpc,
        phraseCpc: row.phraseCpc,
        exactCpc: row.exactCpc,
      }
      this.seedser.saveConfigAdseedDealers(data).subscribe((r: { message: string, id: number }) => {
        this.uis.openDialog({ head: "Success", msg: r.message });
        this.seedser.refresher.emit(GETNEWVALUES);
      }, (er) => {
      })

    } else {
      this.uis.openDialog({ head: "Oops", msg:"Something going wrong, Please contact admin" })
    }
  }
  IsAnychanged(row: IclientseedDev | IdealerseedDev): boolean {
    let keysMain = Object.keys(row)
    let ignoewKeys = ["oldValues", "selected"]
    let foundChange = false;
    for (let x = 0; x < keysMain.length; x++) {
      let e = keysMain[x]
      if (!ignoewKeys.includes(e)) {
        if (row[e] != row.oldValues[e]) {
          foundChange=true
        break;
        }
      }
    }

    return foundChange
  }

}
